import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, NavLink, withRouter } from "react-router-dom";

// CSS
import "../../css/header/user-nav.css";

const translationKey = "app";

class UserNav extends Component {
	determineUrlClass = type => {
		// Cannot work with window if not in client/browser
		if (typeof window !== "undefined") {
			// Get the url for the requested language
			const envType = `REACT_APP_${type}_URL`;

			// If the current url is the same as the one requested, the link will be "active"
			return window.location.origin.toString() === process.env[envType] ? "active" : "";
		}
	};

	render() {
		const { translationsLoading, translations, reviewer } = this.props;

		return (
			!translationsLoading && (
				<div className="user-nav">
					<span className="link-section language-link">
						<span>{translations.sections[translationKey].language}: </span>
						<Link className={this.determineUrlClass("EN")} to={`/en/`}>
							EN
						</Link>
						{' '}/{' '}
						<Link className={this.determineUrlClass("FR")} to={`/fr/`}>
							FR
						</Link>
					</span>
					<NavLink className="link-section" to={`/faq`}>
						{translations.sections[translationKey].faq}
					</NavLink>
					{this.props.reviewer !== null ? (
						<Link className="link-section" to={`/reviewer`}>
							{translations.sections[translationKey].welcome},{" "}
							<span className="profile-name">{reviewer.user.fname}</span>
						</Link>
					) : (
							<NavLink className="link-section" to="/reviewer/login">
								{translations.sections[translationKey].login}
							</NavLink>
						)}
				</div>
			)
		);
	}
}

const mapStateToProps = state => {
	return {
		translationsLoading:
			state.translations.isLoading[translationKey] === undefined
				? 1
				: state.translations.isLoading[translationKey],
		translations: state.translations.translations,
		reviewer: state.user.reviewer
	};
};

export default withRouter(connect(mapStateToProps)(UserNav));



// WEBPACK FOOTER //
// ./src/components/header/UserNav.js